export enum ApplianceDetailsAdditionalAppliancesFormField {
  AdditionalAppliances = 'additionalAppliances',
}
